//@ts-ignore
import { AudioMessage } from "../components/audioSelection/audioSelector";
import * as model from "../model/queue.model";

export async function saveQueues(auth: any, queues: model.Queue[]) {
  const ret = await model.saveQueues(auth, queues);
  return ret;
}

export function saveSingleQueueIvr(companyId: string, queueId: string) {
  model.saveIvrData({
    singleQueueId: queueId,
    type: "single-queue",
  });
}

export async function saveMultiQueueIvr(
  companyId: string,
  greeting: AudioMessage,
  error: AudioMessage,
  queues: model.Queue[],
  menu?: model.IvrMenuNode
) {
  // Opções faladas da raiz vêm da árvore (mesmo critério do preview em
  // MessagesConfig.tsx) — ausente em contas de 1 nível, mantém o fallback
  // flat de sempre.
  const rootOptions = menu?.options.map((o) => ({
    option: o.option,
    name: o.name,
  }));
  saveIvrAudio(companyId, greeting, false, undefined, rootOptions);
  saveIvrAudio(companyId, error, false, undefined, rootOptions);
  if (menu) {
    await saveIvrMenuAudio(companyId, menu);
  }

  model.saveIvrData({
    singleQueueId: "",
    type: "multi-queue",
    queues,
    forwardQueue: error.type === "queue" ? error : null,
    menu,
  });
}

export async function getIvrData(companyId: string) {
  return await model.getIvrData(companyId);
}

export async function saveIvrAudio(
  companyId: string,
  audio: AudioMessage,
  reusePreview: boolean,
  path?: number[],
  options?: model.IvrMenuOptionLabel[]
) {
  switch (audio?.type) {
    case "text":
      await model.saveTextTTS(audio, reusePreview, path, options);
      break;
    case "predefined":
      await model.savePredefTTS(audio, reusePreview, path, options);
      break;
    case "file":
      if (audio.hasChanged) {
        await model.uploadMessage(audio, companyId, path);
      }
      break;
    case "queue":
      await model.saveForwardQueueError(audio, path);
      break;
    case "none":
      await model.saveNoErrorTTS(audio, path);
      break;
  }
}

// Percorre a árvore e persiste a saudação (+ erro, se definido) de cada
// nó no endereço correto (path.join(".")), incluindo o rótulo das opções
// locais pro auto-append da fala ("Digite 1 para...") — ver "Auto-append
// das opções faladas" em docs/ura-multinivel-contrato.md.
export async function saveIvrMenuAudio(
  companyId: string,
  root: model.IvrMenuNode
) {
  async function walk(node: model.IvrMenuNode, path: number[]) {
    const labels: model.IvrMenuOptionLabel[] = node.options.map((o) => ({
      option: o.option,
      name: o.name,
    }));

    await saveIvrAudio(companyId, node.message, false, path, labels);
    if (node.error) {
      await saveIvrAudio(companyId, node.error, false, path, labels);
    }

    for (const opt of node.options) {
      if (opt.type === "submenu") {
        await walk(opt.node, [...path, opt.option]);
      }
    }
  }

  await walk(root, []);
}
